import styled from 'styled-components';
import { theme, toRem } from 'design';

const SidebarContent = styled.section`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  padding: 0 ${toRem(theme.layout.gutter.small)};

  @media (min-width: ${theme.breakpoint.small}px) {
    padding: 0 ${toRem(theme.layout.gutter.large)};
  }

  @media (min-width: ${theme.breakpoint.large}px) {
    padding: 0 ${toRem(33)};
    flex-grow: 1;
  }
`;

export default SidebarContent;
